



























import { computed, defineComponent, onMounted, watch } from '@vue/composition-api';
import { BrandingHelper } from '@getaccept/lib-shared/src/signing-theme/helpers/branding.helper';
import LobbyCard from '@getaccept/lib-shared/src/lobby/components/LobbyCard.vue';
import DsrUnavailable from '@getaccept/lib-shared/src/lobby/components/DsrUnavailable.vue';
import TopBar from '@getaccept/lib-shared/src/top-bar/components/TopBar.vue';
import { storeToRefs } from 'pinia';
import { BackgroundType } from '@getaccept/lib-shared/src/entity/types/enums/background-type';
import IdentifyParticipantUniversal from '@getaccept/dsr-published-site/src/identify/components/IdentifyParticipantUniversal.vue';
import { useThemeStore } from '../../theme/theme.store';
import IdentifyRecipientModal from './IdentifyRecipientModal.vue';
import { useUniversalLink } from './composables/universal-link.composable';

export default defineComponent({
  components: {
    TopBar,
    LobbyCard,
    IdentifyRecipientModal,
    IdentifyParticipantUniversal,
    DsrUnavailable,
  },
  setup(_, { root }) {
    const themeStore = useThemeStore();
    const { theme } = storeToRefs(themeStore);

    const universalId = computed(() => root.$route.params['universalId']);

    const {
      loading,
      failedToVerify,
      verifyLinkResponse,
      verifyLink,
      failedRestricted,
      universalLinkStorage,
    } = useUniversalLink();

    const hasFixedBackground = computed(
      () =>
        !theme.value ||
        theme.value.backgroundType === BackgroundType.Fixed ||
        !theme.value.backgroundImage
    );

    const backgroundStyle = computed(() =>
      theme.value?.backgroundImage
        ? `background-image: url(${theme.value?.backgroundImage});`
        : `background-image: url('/assets/img/background/signing-page-bg.svg');`
    );

    onMounted(() => {
      if (universalLinkStorage.value?.redirectURL) {
        const url = new URL(universalLinkStorage.value.redirectURL);
        url.searchParams.set('universalLinkURL', window.location.href);
        window.location.href = url.toString();
        return;
      }
      verifyLink(universalId.value);
    });

    const documentLogoUrl = computed(() => BrandingHelper.getLogoUrl(theme.value));

    const documentId = computed(() => verifyLinkResponse.value?.documentId);

    const isDsr = computed(() => verifyLinkResponse.value?.documentType === 'dsr');

    watch(documentId, () => {
      if (documentId.value) {
        themeStore.loadTheme(documentId.value);
      }
    });

    return {
      loading,
      failedToVerify,
      verifyLinkResponse,
      documentLogoUrl,
      documentId,
      backgroundStyle,
      isDsr,
      failedRestricted,
      hasFixedBackground,
    };
  },
});
